import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";

const JamforElpriser = lazy(() => import("@/pages/elpriser/JamforElpriser"));

export const Route = createFileRoute("/elpriser/jamfor")({
  head: () => seoHead("/elpriser/jamfor"),
  component: () => <JamforElpriser />,
});
